import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "../integrations/supabase/supabaseTypes";

export interface PlayerProfileUpsertInput {
  readonly ownerId: string;
  readonly ownerKind: "anonymous" | "signedIn";
}

export interface PlayerProfileRepository {
  upsert(input: PlayerProfileUpsertInput): Promise<void>;
}

export function createPlayerProfileRepository(
  client: SupabaseClient<Database>,
): PlayerProfileRepository {
  return {
    async upsert(input) {
      const { error } = await client
        .from("player_profiles")
        .upsert({ owner_id: input.ownerId }, { onConflict: "owner_id" });
      if (error) {
        throw new Error(
          `Failed to upsert player_profiles for owner ${input.ownerId}: ${error.message}`,
        );
      }
    },
  };
}
